<app-middle-single-container>
    
    <div class="volta-icon">
        <img [src]="VoltaCommon.VOLTA_ICON"/>
    </div>

    <div class="theme-icon">
        <app-theme-mode-button/>
    </div>

    <div class="mb-4 text-center">
        <h1 class="font-tertiary font-semibold mb-2">Welcome to {{VoltaCommon.VOLTA_NAME}}</h1>
        <p class="font-light">Enter your credentials below to access the system</p>
    </div>
    
    <div class="col-10 col-md-8">
        <app-login-form (login)="onLogin()"/>

        <div class="d-flex flex-row m-0 p-0 mt-5 justify-content-center align-items-center gap-3">

            <hr class="col m-0 flex-grow"/>

            <div class="d-flex justify-content-center align-items-center">
                <app-forgot-password/>
            </div>

            <hr class="col m-0 flex-grow"/>

        </div>
    </div>

</app-middle-single-container>
